// src/pages/History.jsx
import React from 'react';
import { motion } from 'framer-motion';
// removed unused imports
import NavTabs from '../components/NavTabs';

const timeline = [
  {
    year: "24",
    events: [
      { month: '9', text: 'iM캐피탈 캠페인서비스 오픈' },
      { month: '6', text: 'AICC 솔루션 GS인증(1등급)\n무인상담 서비스 오픈\n- TKK\n- 위니아에이드' },
      { month: '5', text: 'AICC 신규 계약\n- SK텔레콤, 기아차, 공영홈쇼핑, 서울소방' }
    ]
  },
  {
    year: "23",
    events: [
      { month: '10', text: '하이서울 인증' },
      { month: '9', text: '구독형 무인상담 SaaS 서비스 오픈\n솔루션 고도화 (CINNAMON 2.0)' },
      { month: '5', text: '삼성생명 화상상담 오픈' },
      { month: '2', text: '현대자동차 화상상담 오픈' }
    ]
  },
  {
    year: "22",
    events: [
      { month: '8', text: '보건복지부 상담가이드봇 서비스 오픈\n이노비즈 인증' },
      { month: '5', text: '신한 오픈 이노베이션 6기 선정' },
      { month: '4', text: '정부과제 선정 (대화형 ARS)\n홈앤쇼핑 주소봇 서비스 오픈\nw쇼핑 주소봇 서비스 오픈' },
      { month: '3', text: 'LG 유플러스 소상공인 AI 서비스 협력사 선정' }
    ]
  },
  {
    year: "20",
    events: [
      { month: '5', text: '제이디윈테크 설립' }
    ]
  }
];

function History() {

  return (
    <div className="text-gray-800">
      {/* 배경 이미지 Hero 섹션 */}
      <section className="relative h-[60vh] bg-[url('hero-bg.jpg')] bg-cover bg-center flex items-center justify-center">
        <div className="absolute inset-0 bg-black bg-opacity-50" />
        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white">제이디윈태크</h1>
          <p className="mt-4 text-white text-lg md:text-xl">
            JDWinTech은 스마트 공조와 배연 시스템의 선도 기업입니다.
          </p>
        </div>

        {/* 하단 탭 메뉴 */}
        <NavTabs />
      </section>

      {/* 연혁 타임라인 섹션 */}
      <section className="py-16 px-6 md:px-20 max-w-5xl mx-auto">
        <h2 className="text-2xl font-bold mb-8 text-center">회사 연혁</h2>
        <div className="relative border-l-4 border-gray-200 ml-5">
          {timeline.map((block, idx) => (
            <div key={idx} className="mb-12 pl-6 relative">
              <div className={`absolute -left-[35px] top-0 w-14 h-14 ${block.year === "20" ? 'bg-green-500' : 'bg-red-500'} text-white rounded-full flex items-center justify-center font-bold text-xl shadow-md`}>
                {block.year}
              </div>
              {block.events.map((event, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  viewport={{ once: true }}
                  className="mb-6 ml-10"
                >
                  <p className="text-sm text-gray-500 font-medium">{event.month}월</p>
                  <p className="whitespace-pre-line font-medium text-gray-800">{event.text}</p>
                </motion.div>
              ))}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default History;
